<template>
    <div class="container">
        <div class="main__top">
            <h1 class="main__title wow fadeInDown" data-wow-duration="1.5s">Clients</h1>
        </div>

        <div class="clients">
            <div class="links-panel" v-if="isPermission">
                <a href="javascript:void(0)" class="registration-link">Registration</a>
                <button
                    type="button"
                    class="btn btn_primary-outline generate-link"
                    @click="getLinkForRegistration"
                >generate link</button>
                <div class="holder" :class="{show : registrationLink}">
                    <input type="text" class="txt" :value="registrationLink">
                    <button type="submit" class="btn" @click="copyLink">copy</button>
                </div>
            </div>
            <div class="clients__search">
                <input
                    type="text"
                    class="txt"
                    placeholder="Search by Name"
                    v-model.trim="filters.search"
                    @keydown.enter="updateListOfClients"
                >
                <button
                    type="submit"
                    class="sbm"
                    area-label="Search Submit"
                    @click.prevent="updateListOfClients"
                >
                    <svg width="18" height="18" class="icon">
                        <use href="/img/svg/symbol-defs.svg#icon-search"></use>
                    </svg>
                </button>
            </div>
            <div class="filter mt-0">
                <span class="filter__label">Filter:</span>
                <form action="">
                    <div class="row justify-content-between">
                        <div class="col-6 col-md-3">
                            <div class="filter__item">
                                <select
                                    class="custom-select"
                                    v-model="filters.status"
                                    @change="updateListOfClients"
                                >
                                    <option
                                        :value="null"
                                        selected
                                    >
                                        Select Status
                                    </option>
                                    <option
                                        v-for="(status, index) in clientStatuses"
                                        :key="index"
                                        :value="status"
                                    > {{ status }}
                                    </option>

                                </select>
                            </div>
                        </div>
                        <div class="col-6 col-md-3">
                            <div class="filter__item">
                                <div class="form">
                                    <div class="show-num">
                                        <label class="show-num__label">Show:</label>
                                        <select
                                            class="custom-select pl-3"
                                            @change="updateListOfClients"
                                            v-model="filters.perPage"
                                        >
                                            <option value="10">10</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="clients__table">
                <div class="clients__top">
                    <div class="clients__photo"></div>
                    <div class="clients__name">
                        <a href="javascript:void(0)" @click.prevent="changeSortList('first_name')">First name <i class="fa-solid fa-sort"></i></a>
                    </div>
                    <div class="clients__surname">
                        <a href="javascript:void(0)" @click.prevent="changeSortList('last_name')">Last Name <i class="fa-solid fa-sort"></i></a>
                    </div>
                    <div class="clients__position">
                        <a href="javascript:void(0)" @click.prevent="changeSortList('position')">Position <i class="fa-solid fa-sort"></i></a>
                    </div>
                    <div class="clients__company">
                        <a href="javascript:void(0)" @click.prevent="changeSortList('company')">Company <i class="fa-solid fa-sort"></i></a>
                    </div>
                    <div class="clients__status">
                        <a href="javascript:void(0)" @click.prevent="changeSortList('status')">status <i class="fa-solid fa-sort"></i></a>
                    </div>
                    <div class="clients__delete"></div>
                </div>
                <ul class="clients__list">
                    <li
                        class="clients__line"
                        v-for="client in clients.data"
                        :key="client.id"
                    >
                        <div class="clients__photo">
                        </div>
                        <div class="clients__name">
                            <a :href="`/admin/client/${client.id}/update`" class="name">{{ client.user.first_name }}</a>
                        </div>
                        <div class="clients__surname">
                            <a :href="`/admin/client/${client.id}/update`" class="name"> {{ client.user.last_name}}</a>
                        </div>
                        <div class="clients__position">
                            <p>{{ client.position }}</p>
                        </div>
                        <div class="clients__company">
                            <p>{{ client.company.name }}</p>
                        </div>
                        <div class="clients__status">
                            <div class="clients__select">
                                <span class="clients__selected clients__selected_pending">
                                    <i class="fa-solid fa-chevron-down"  v-if="isPermission"></i> {{ client.status }}</span>
                                <div class="clients__tool"  v-if="isPermission">
                                    <button
                                        v-for="(status, index) in clientStatuses"
                                        :key="index"
                                        type="button"
                                        @click="updateClientStatus(status, client)"
                                        class="artists__action artists__action_pending"
                                        :class=" client.status === status ? `artists__action_selected` : ''"
                                    >
                                        {{ status }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="clients__delete">
                            <button
                                v-if="isPermission"
                                class="delete"
                                area-label="Remove Item"
                                @click="openDeleteModal(client.id)"
                            >
                                <svg width="16" height="16" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
                                </svg>
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
            <ActionModal
                :modal-id="getCustomModalId('delete',currentClientId)"
                @confirm="deleteClient(currentClientId)"
                :reject-text="`No`"
                :confirm-text="`Yes`"
            >
                <template #body>
                    <div class="text-center mb-4">
                        <div class="text-center">
                            <h5 class="title">Are you sure ?</h5>
                            <p>Do you want to delete this artist?</p>
                        </div>
                    </div>
                </template>
            </ActionModal>

            <Pagination
                :last-page="clients.last_page"
                :current-page="clients.current_page"
                @changePage="changePage"
            />
        </div>
    </div>
</template>

<script>
import {defineComponent, nextTick} from 'vue'
import Pagination from "../Common/Pagination.vue";
import AdminService from "../../services/AdminService";
import {mapActions, mapState} from "pinia";
import {useAdminStore} from "../../stores/AdminStore";
import ActionModal from "../Common/ActionModal.vue";
import ModalHandler from "../../mixins/ModalHandler";

export default defineComponent({
    name: "ListOfClients",
    components: {ActionModal, Pagination},
    mixins: [ModalHandler],
    data() {
        return {
            registrationLink: null,
            currentClientId: null,
            userType: null,
            filters: {
                search: '',
                page: 1,
                perPage: 10,
                status: null,
                orderColumn: 'first_name',
                orderDirection: 'asc'
            }
        }
    },
    computed: {
      ...mapState(useAdminStore, {
          clients: 'clients',
          clientStatuses: 'clientStatuses',
      }),
        isPermission() {
            return this.userType === 'admin';
        },
    },
    mounted() {
        this.getAdminType()
        this.fetchListOfClients(this.filters)
        this.fetchListOfClientStatuses()
    },
    methods: {
        async getAdminType() {
            try {
                const response = await AdminService.getAdminType()

                this.userType = response.data
            } catch (error) {
                this.$showErrorMessage('Status was not updated')
                console.error(error)
            }
        },

        ...mapActions(useAdminStore, {
            fetchListOfClients: 'fetchListOfClients',
            fetchListOfClientStatuses: 'fetchListOfClientStatuses'
        }),
        updateListOfClients() {
            this.fetchListOfClients(this.filters)
        },
        changePage(page) {
            this.filters.page = page
            this.fetchListOfClients(this.filters)
        },
        changeSortList(field) {
            if (this.filters.orderColumn === field) {
                this.filters.orderDirection = this.filters.orderDirection === 'asc' ? 'desc' : 'asc';
            }
            this.filters.orderColumn = field
            this.fetchListOfClients(this.filters)
        },
        copyLink() {
            navigator.clipboard.writeText(this.registrationLink)
        },
        openDeleteModal(id) {
            this.currentClientId = id
            nextTick(() => {
                this.showCustomModal('delete', id);
            });
        },
        async deleteClient(id) {
            try {
                await AdminService.deleteClient(id)
                this.$showSuccessMessage('The Client was deleted')
            } catch (e) {
                this.$showErrorMessage('The Client was not deleted, please try again')
            }
        },
        async updateClientStatus(status, client) {
            client.status = status
            try {
                await AdminService.updateClientStatus(client.id, status)
                this.$showSuccessMessage('Status was updated')
            } catch (error) {
                this.$showErrorMessage('Status was not updated')
                console.error(error)
            }
        },
        async getLinkForRegistration() {
            this.$showLoadingMessage()
            try {
                const { data: response } =  await AdminService.getRegistrationLink('client')
                this.registrationLink = response.url
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Status was not updated')
            }
        },
    }
})
</script>



<style scoped>

</style>
